import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Layout from "../../../components/dashboard/Layout";
import AddAnnouncement from "../../../containers/admin/announcements/models/add-announcement";
import SearchBar from "../../../containers/admin/announcements/searchbar";
import AnnouncementsTable from "../../../containers/admin/announcements/table";
import { getAllAnnouncementsRequest } from "../../../modules/admin-modules/announcements/Actions";

const Announcements = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const model = useSelector((state) => state.model);
  const announcements = useSelector((state) => state.announcements.announcements);
  const user = useSelector((state) => state.user.userData);
  const isLoading = useSelector((state) => state.user.isLoading);
  const [isAdd, setAdd] = useState(false);
  const [selectedData, setSelectedData] = useState({});

  useEffect(() => {
    // Wait for user data to load before checking
    if (isLoading) {
      return;
    }

    // Only redirect if user data is loaded and user is not Super Admin
    if (user?.role && Array.isArray(user.role)) {
      const isSuperAdmin = user.role[0]?.name === "Super Admin";
      if (!isSuperAdmin) {
        navigate("/dashboard/students");
        return;
      }
      // Only fetch announcements if user is Super Admin
      dispatch(getAllAnnouncementsRequest());
    }
  }, [user, isLoading, navigate, dispatch]);

  // Show nothing while loading or if user data is not available yet
  if (isLoading || !user?.role) {
    return null;
  }

  // Check if user is Super Admin before rendering
  const isSuperAdmin = user?.role && Array.isArray(user.role) && user.role[0]?.name === "Super Admin";
  if (!isSuperAdmin) {
    return null;
  }

  return (
    <Layout>
      <SearchBar setAdd={setAdd} setSelectedData={setSelectedData} announcements={announcements} />
      <AnnouncementsTable setAdd={setAdd} setSelectedData={setSelectedData} />
      <AddAnnouncement
        isAdd={isAdd}
        data={selectedData}
        setSelectedData={setSelectedData}
      />
    </Layout>
  );
};

export default Announcements;

